import _ from "lodash";
import moment from "moment";
import { DateUtils } from "~app/common/utils/date-utils";
import { IViol3DestineringsradDto } from "~app/features/planera/model/IViol3DestineringsradDto";
import { IRedovisningshanvisningDto } from "../model/IRedovisningshanvisningDto";
import { InmatningshandelssortimentRedovisningshanvisningDto } from "../model/IViol3DestineringDto";

export class Viol3DestineringRowViewModel {
    redovisningshanvisningIdentitet: string;
    inmatningshandelssortiment: string;
    produceratHandelssortiment: string;
    giltigFrom: string;
    giltigTom: string;
    skickad: boolean;
    sourceDto: IViol3DestineringsradDto;
    applicableRedovisningshanvisningar: IRedovisningshanvisningDto[];
    redovisningshanvisning: IRedovisningshanvisningDto;
    isEditable: boolean;

    constructor(x: IViol3DestineringsradDto, applicableRh: IRedovisningshanvisningDto[], isEditable: boolean) {
        this.giltigFrom = x.giltigFrom ? moment(x.giltigFrom).format(DateUtils.dateformat) : null;
        this.giltigTom = x.giltigTom ? moment(x.giltigTom).format(DateUtils.dateformat) : null;
        this.inmatningshandelssortiment = x.inmatningshandelssortiment;
        this.produceratHandelssortiment = x.produceratHandelssortiment;
        this.redovisningshanvisningIdentitet = x.redovisningshanvisning?.identitet;
        this.redovisningshanvisning = x.redovisningshanvisning;
        this.skickad = x.skickad;
        this.sourceDto = x;
        this.isEditable = !x.skickad;
        this.applicableRedovisningshanvisningar = applicableRh;
    }

    get skickadTxt(): string {
        return this.skickad ? "Ja" : "Nej";
    }

    static create(input: InmatningshandelssortimentRedovisningshanvisningDto[]): Viol3DestineringRowViewModel[] {
        const destineringsrader = input.map(x => x.viol3Destineringsrader).reduce((prev, curr) => prev.concat(curr), []);
        const editableRows = _.chain(destineringsrader)
            .groupBy(x => x.inmatningshandelssortiment)
            .map(x => _.sortBy(x, ord => ord.skickad === false, ord => ord.giltigFrom)[0])
            .value();

        return input.map(x => x.viol3Destineringsrader
            .map(d => ({ destinering: d,
                rh: x.applicableRedovisningshanvisningar })))
            .reduce((prev, curr) => prev.concat(curr), []).map(x => {
                const isEditable = editableRows.some(row => row === x.destinering);
                return new Viol3DestineringRowViewModel(x.destinering, x.rh, isEditable);
            });
    }
}
